import { Button } from 'rsuite';
import React, { Dispatch, SetStateAction } from 'react';
import { FormModal } from '../../../common/FormModal';
import { useObjectField } from '../../../common/useObjectField';
import CourseModalContent from './CourseModalContent';

type Props = {
  modalCourseObject?: {
    id: string;
    name: string;
    cipher: string;
    nameEn: string;
    nameDe: string;
    description: string;
    descriptionEn: string;
    descriptionDe: string;
    shortDescription: string;
    shortDescriptionEn: string;
    shortDescriptionDe: string;
    active: boolean;
    acceptsRequests: boolean;
    priority: number;
  };
  handleModalClose: () => void;
  setModalCourseObject: Dispatch<
    SetStateAction<{
      id: string;
      name: string;
      cipher: string;
      nameEn: string;
      nameDe: string;
      description: string;
      descriptionEn: string;
      descriptionDe: string;
      shortDescription: string;
      shortDescriptionEn: string;
      shortDescriptionDe: string;
      active: boolean;
      acceptsRequests: boolean;
      priority: number;
    }>
  >;
  submit: () => Promise<void>;
  errorSummary?: string[];
};

export default function EditCourseModal({
  modalCourseObject,
  setModalCourseObject,
  handleModalClose,
  submit,
  errorSummary = [],
}: Props) {
  const setActive = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'active'
  );
  const setAcceptsRequests = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'acceptsRequests'
  );
  const setName = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'name'
  );
  const setCipher = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'cipher'
  );
  const setNameEn = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'nameEn'
  );
  const setNameDe = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'nameDe'
  );
  const setDescription = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'description'
  );
  const setDescriptionEn = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'descriptionEn'
  );
  const setDescriptionDe = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'descriptionDe'
  );
  const setShortDescription = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'shortDescription'
  );
  const setShortDescriptionEn = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'shortDescriptionEn'
  );
  const setShortDescriptionDe = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'shortDescriptionDe'
  );
  const setPriority = useObjectField(
    modalCourseObject,
    setModalCourseObject,
    'priority'
  );

  return (
    <FormModal
      open={!!modalCourseObject}
      onClose={handleModalClose}
      title="Редагувати курс"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={submit} appearance="primary">
            Зберегти
          </Button>
          <Button onClick={handleModalClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      {modalCourseObject && (
        <CourseModalContent
          modalCourseName={modalCourseObject.name}
          modalCourseCipher={modalCourseObject.cipher}
          modalCourseActive={modalCourseObject.active}
          modalCourseAcceptsRequests={modalCourseObject.acceptsRequests}
          modalCourseDescription={modalCourseObject.description}
          modalCourseNameEn={modalCourseObject.nameEn}
          modalCourseNameDe={modalCourseObject.nameDe}
          modalCourseDescriptionEn={modalCourseObject.descriptionEn}
          modalCourseDescriptionDe={modalCourseObject.descriptionDe}
          modalCourseShortDescription={modalCourseObject.shortDescription}
          modalCourseShortDescriptionEn={modalCourseObject.shortDescriptionEn}
          modalCourseShortDescriptionDe={modalCourseObject.shortDescriptionDe}
          modalCoursePriority={modalCourseObject.priority}
          setModalCourseActive={setActive}
          setModalCourseAcceptsRequests={setAcceptsRequests}
          setModalCourseName={setName}
          setModalCourseCipher={setCipher}
          setModalCourseNameEn={setNameEn}
          setModalCourseNameDe={setNameDe}
          setModalCourseDescription={setDescription}
          setModalCourseDescriptionEn={setDescriptionEn}
          setModalCourseDescriptionDe={setDescriptionDe}
          setModalCourseShortDescription={setShortDescription}
          setModalCourseShortDescriptionEn={setShortDescriptionEn}
          setModalCourseShortDescriptionDe={setShortDescriptionDe}
          setModalCoursePriority={setPriority}
        />
      )}
    </FormModal>
  );
}
